import { gql } from '@apollo/client'

export const RUN_RECEIVED_EMAILS_MUTATION = gql`
  mutation runReceivedEmails($ids: [ID!]!) {
    runReceivedEmails(ids: $ids)
  }
`
